import { ColumnsType } from "antd/lib/table"
import { News } from "../../../graphql/fragments"

export default (): ColumnsType<News>[number] => ({
  title: "Title",
  dataIndex: "title",
  ellipsis: true,
})
